import { useCallback, useEffect } from 'react';
const useOutsideClick = (options) => {
    const { elements, callback, active } = options;
    const handlePress = useCallback((e) => {
        const allElements = Array.isArray(elements) ? elements : [elements];
        const clickedInside = allElements.find((ref) => {
            var _a;
            if (e.target instanceof Node && !((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                return false;
            }
            return true;
        });
        if (!clickedInside && active) {
            callback();
        }
    }, [active, callback, elements]);
    useEffect(() => {
        window.addEventListener('pointerdown', handlePress);
        return () => {
            window.removeEventListener('pointerdown', handlePress);
        };
    }, [handlePress]);
};
export { useOutsideClick };
